<template>
  <div class="vue-template">
    <div class="jumbotron bg-gradient">
      <div class="container">
        <span
          class="d-flex align-items-center mb-5
             "
          onclick="
            window.history.go(-1);
            return false;
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            fill="currentColor"
            class="icon-20"
          >
            <path
              d="M 10.8125 9.28125 L 4.09375 16 L 10.8125 22.71875 L 12.21875 21.28125 L 7.9375 17 L 28 17 L 28 15 L 7.9375 15 L 12.21875 10.71875 Z"
              fill="currentColor"
            />
          </svg>
          Zurück</span
        >
        <h1 class="display-4" v-if="book.bookData.title">
          {{ book.bookData.title }}
        </h1>
        <h2 v-if="book.bookData.subtitle">
          {{ book.bookData.subtitle | truncate(19) }}
        </h2>
      </div>
    </div>
    <div class="container">
      <pre>{{ book }}</pre>
      <button class="btn btn-outline-danger" @click="deleteBook(book.id)">
        Delete
      </button>
      <div class="books-item-actions d-none">
        <div
          class="btn btn-primary mr-3 btn-sm"
          @click="borrowBook(book, book.owner)"
          v-if="book.owner !== currentUser.id"
        >
          Borrow
        </div>
        <div
          v-if="currentUser.admin"
          class="icon-20"
          @click="deleteBook(book.id)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class=" pl-2">
            <path
              viewBox="0 0 11 13"
              d="M4.496 0C3.676 0 3 .676 3 1.496V2H0v1h1v8.5c0 .824.676 1.5 1.5 1.5h6c.824 0 1.5-.676 1.5-1.5V3h1V2H8v-.504C8 .676 7.324 0 6.504 0H4.496zm0 1h2.008c.281 0 .496.215.496.496V2H4v-.504C4 1.215 4.215 1 4.496 1zM2 3h7v8.5c0 .281-.219.5-.5.5h-6a.494.494 0 01-.5-.5V3zm1 1v7h1V4H3zm2 0v7h1V4H5zm2 0v7h1V4H7z"
              fill="currentColor"
              fill-rule="nonzero"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      book: {
        id: this.$route.params.id,
        bookData: [],
      },
      loggedinUser: null,
    };
  },
  created() {
    this.getBookDetails();
  },
  computed: mapState({
    books: state => state.books,
    currentUser: state => state.currentUser,
  }),
  methods: {
    getBookDetails() {
      let vm = this;
      firebase
        .firestore()
        .collection('books')
        .doc(this.$route.params.id)
        .onSnapshot(function(doc) {
          // console.log(doc.data());
          vm.book.bookData = doc.data();
        });
    },
    borrowBook(book, myID) {
      this.$store.dispatch('borrowBook', { book, myID });
    },
    deleteBook(id) {
      this.$store.dispatch('removeBook', id);
      this.$router.go(-1);
    },
    deleteBookOld(id) {
      let vm = this;
      firebase
        .firestore()
        .collection('books')
        .doc(id)
        .delete()
        .then(function() {
          // console.log('Document successfully deleted!');
          vm.$router.go(-1);
        })
        .catch(function(error) {
          return error;
          // console.error('Error removing document: ', error);
        });
    },
  },
};
</script>
